import { render, staticRenderFns } from "./testimonial-section.vue?vue&type=template&id=2e1b7506&scoped=true&"
import script from "./testimonial-section.vue?vue&type=script&lang=js&"
export * from "./testimonial-section.vue?vue&type=script&lang=js&"
import style0 from "./testimonial-section.vue?vue&type=style&index=0&id=2e1b7506&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1b7506",
  null
  
)

export default component.exports